import Vue from 'vue/dist/vue.js';

Vue.config.productionTip = false;

export default {
    name      : 'news',
    _apiUrl   : '/actions/tellus/news/index',
    _container: null,
    init() {
        this._container = document.querySelector('[data-news]');
        
        if (!this._container) {
            return;
        }
        
        new Vue({
            el: this._container,
            delimiters: ['${', '}'],
            data: {
                language : '',
                apiUrl              : this._apiUrl,
                offset              : 0,            // offset of pagination (which page am I viewing)
                limit               : 10,           // amount of products to show per page
                pagesVisible        : 7,            // amount of pages visible at the same time in the pagination
                news                : []
            },
            created() {
                const container = document.querySelector('[data-news]');
                this.language = typeof container.dataset.language === 'string' && container.dataset.language.length && container.dataset.language != 'nb' ?
                container.dataset.language :
                '';

                if (this.language.length) {
                    this.apiUrl = '/'+this.language+this.apiUrl;
                }

                this.fetchNews();
            },
            methods: {
                fetchNews() {
                    const request = new XMLHttpRequest();
                    request.addEventListener('load', () => {
                        if (request.readyState === 4 && request.status === 200) {
                            const res = JSON.parse(request.responseText);
                            this.news = res.items;
                        }
                    });

                    request.open('GET', this.apiUrl);
                    request.send();
                },
                goTo(index) {
                    window.scrollTo(0,0);
                    this.offset = index;
                },
            },
            computed: {
                paginatedNews() {
                    const currentPage = this.offset * this.limit; 
                    
                    return this.news.slice(currentPage, currentPage + this.limit);
                },
                pages() {
                    if (!this.news.length) {
                        return [];
                    }

                    // Array from 0 to n pages [0, 1, 2, ..., n]
                    const arr = [...Array(Math.ceil(this.news.length / this.limit)).keys()]; 

                    if (arr.length < 7) {
                        return arr;
                    }
                    
                    // Show the same amount of pages before and after the selected page
                    const eitherSide = Math.floor(this.pagesVisible / 2);                                 

                    const length = arr.length;
                    const left   = this.offset - eitherSide > 0 ? this.offset - eitherSide : 0;
                    const limit  = length - this.pagesVisible;
                    
                    const start  = left  > limit ? limit : left;
                    const end    = start + this.pagesVisible;

                    return arr.slice(start, end);
                }
            }
        });
    }
}